import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import MaterialGuide from '@trashlab/sitesapp/src/organizations/fasttrac/template/components/dumpster-faq/material-guide';
import { DumpsterDetails } from '@trashlab/sitesapp/src/organizations/fasttrac/template/components/dumpster-rentals/dumpster-details';
import { CtaSection } from '@trashlab/sitesapp/src/organizations/fasttrac/template/components/shared/cta-section';

const DumpsterDetailPage = () => {
  const { dumpsterId } = Route.useParams() as { dumpsterId: string };

  return (
    <>
      <DumpsterDetails skuId={dumpsterId} />
      <CtaSection secondary />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dumpster-rentals/$dumpsterId',
  parseParams: (params: Record<string, string>) => ({
    dumpsterId: params.dumpsterId,
  }),
  component: DumpsterDetailPage,
});
